module.exports = __webpack_public_path__ + "static/img/green_dence.8ca91aaa.png";